import {defaultState} from './state';
import * as CatalogActions from '../actions/CatalogActions';
import * as UIActions from '../actions/UIActions';
import * as WizardMXActions from '../actions/WizardMXActions';
import {
    CalculatorApplicantSummaryDTO,
    DesiredVehicleApplicantSummaryDTO,
    FieldApplicantSummary
} from '../types/mx/creditoReal/epics';
import {CalculatorStepViewFieldErrorState} from '../types/mx/creditoReal/reducers';
import {DEFAULT_YEAR} from '../constants/MotorcreditConstants';
import * as StateConstants from '../constants/StateConstants';
import * as UTMActions from '../actions/UTMActions';
import {isNumber} from '../utils/ValidationUtils';
import * as CookieUtils from '../../common/utils/CookieUtils';
import * as CalculatorActions from '../actions/CalculatorActions';
import * as WizardActions from '../actions/WizardActions';
import * as LoginActions from '../actions/LoginActions';
import {EMPTY_STRING} from '../../wizard-motorfy/constants/GlobalConstants';

const catalogs = (state = defaultState.catalogs, action) => {
    switch (action.type) {
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            CookieUtils.deleteCookie(StateConstants.YEAR_SELECTED);
            CookieUtils.deleteCookie(StateConstants.BRAND_SELECTED);
            CookieUtils.deleteCookie(StateConstants.MODEL_SELECTED);
            CookieUtils.deleteCookie(StateConstants.VERSION_SELECTED);
            CookieUtils.deleteCookie(StateConstants.POSTAL_CODE);
            CookieUtils.deleteCookie(StateConstants.ID_VEHICLE);
            CookieUtils.deleteCookie(StateConstants.GROUP_LOCATION);
            CookieUtils.deleteCookie(StateConstants.ORIGINAL_PHOTO);
            CookieUtils.deleteCookie(StateConstants.THUMBNAIL_PHOTO);
            CookieUtils.deleteCookie(StateConstants.VEHICLE_PREMIUM_INFO);
            return {
                ...state,
                terms: [],
                models: [],
                versions: [],
                yearSelected: DEFAULT_YEAR,
                queryStringBrand: EMPTY_STRING,
                queryStringModel: EMPTY_STRING,
                queryStringVersion: EMPTY_STRING,
                queryStringProvince: EMPTY_STRING,
                queryStringIdVehicle: EMPTY_STRING,
                queryStringGroupName: EMPTY_STRING,
                queryStringGroupId: EMPTY_STRING,
                queryStringGroupLocation: EMPTY_STRING,
                queryStringOriginalPhoto: EMPTY_STRING,
                queryStringThumbnailPhoto: EMPTY_STRING,
                isUrlFromPI: false,
            };
        case UTMActions.SET_VEHICLE_UTM_VALUES_ON_SIMULATOR.name:
            const year: number = !!action.year && isNumber(action.year) ? parseFloat(action.year) : 0;
            CookieUtils.setCookie(StateConstants.ID_VEHICLE, action.idVehicle, 1);
            CookieUtils.setCookie(StateConstants.GROUP_NAME, action.groupName, 1);
            CookieUtils.setCookie(StateConstants.GROUP_ID, action.groupId, 1);
            CookieUtils.setCookie(StateConstants.GROUP_LOCATION, action.groupLocation, 1);
            CookieUtils.setCookie(StateConstants.ORIGINAL_PHOTO, action.originalPhoto, 1);
            CookieUtils.setCookie(StateConstants.THUMBNAIL_PHOTO, action.thumbnailPhoto, 1);
            CookieUtils.setCookie(StateConstants.THUMBNAIL_PHOTO, action.thumbnailPhoto, 1);
            CookieUtils.setCookie(StateConstants.VEHICLE_PREMIUM_INFO, action.vpiQS, 1);
            return {
                ...state,
                queryStringYear: year,
                queryStringBrand: action.brand,
                queryStringModel: action.model,
                queryStringVersion: action.version,
                queryStringProvince: action.province,
                queryStringIdVehicle: action.idVehicle,
                queryStringGroupName: action.groupName,
                queryStringGroupId: action.groupId,
                queryStringGroupLocation: action.groupLocation,
                queryStringOriginalPhoto: action.originalPhoto,
                queryStringThumbnailPhoto: action.thumbnailPhoto,
                isUrlFromPI: action.isUrlFromPI,
            };
        case LoginActions.SET_REDIRECT_URL_ACTION.name:
            CookieUtils.setCookie(StateConstants.ID_VEHICLE, state.queryStringIdVehicle, 1);
            CookieUtils.setCookie(StateConstants.GROUP_NAME, state.queryStringGroupName, 1);
            CookieUtils.setCookie(StateConstants.GROUP_ID, state.queryStringGroupId, 1);
            CookieUtils.setCookie(StateConstants.GROUP_LOCATION, state.queryStringGroupLocation, 1);
            CookieUtils.setCookie(StateConstants.ORIGINAL_PHOTO, state.queryStringOriginalPhoto, 1);
            CookieUtils.setCookie(StateConstants.THUMBNAIL_PHOTO, state.queryStringThumbnailPhoto, 1);
            return state;
        case CatalogActions.GOT_YEARS_ACTION.name:
            return {
                ...state,
                years: action.years
            };
        case CatalogActions.GOT_EMPLOYMENT_TYPES_ACTION.name:
            return {
                ...state,
                employmentTypes: action.employmentTypes
            };
        case CatalogActions.GOT_PROVINCES_ACTION.name:
            return {
                ...state,
                provinces: action.provinces,
                queryStringProvince: ''
            };

        case CatalogActions.GOT_BRANDS_ACTION.name:
            return {
                ...state,
                brands: action.brands,
                queryStringBrand: ''
            };
        case CatalogActions.GOT_MODELS_ACTION.name:
            return {
                ...state,
                models: action.models,
                queryStringModel: ''
            };
        case CatalogActions.GOT_VERSIONS_ACTION.name:
            return {
                ...state,
                versions: action.versions,
                queryStringVersion: ''
            };
        case CalculatorActions.YEAR_SELECTED_ACTION.name:
            return {
                ...state,
                brands: [],
                models: [],
                versions: []
            };
        case CalculatorActions.BRAND_SELECTED_ACTION.name:
            return {
                ...state,
                models: [],
                versions: []
            };
        case CalculatorActions.MODEL_SELECTED_ACTION.name:
            return {
                ...state,
                versions: []
            };
        case WizardMXActions.SET_CALCULATOR_DATA_STATE_ACTION.name:
            const calculatorDataFS: FieldApplicantSummary<CalculatorApplicantSummaryDTO,
                CalculatorStepViewFieldErrorState> = action.fieldSummary;
            const calculatorSummary: CalculatorApplicantSummaryDTO = calculatorDataFS.data;
            return {
                ...state,
                provinceSelected: calculatorSummary.state,
            };
        case WizardMXActions.SET_DESIRED_VEHICLE_DATA_STATE_ACTION.name:
            const vehicleDataFS: FieldApplicantSummary<DesiredVehicleApplicantSummaryDTO,
                CalculatorStepViewFieldErrorState> = action.fieldSummary;
            const vehicleSummary: DesiredVehicleApplicantSummaryDTO = vehicleDataFS.data;
            return {
                ...state,
                brandSelected: vehicleSummary.brand,
                modelSelected: vehicleSummary.model,
                versionSelected: vehicleSummary.version,
                yearSelected: {
                    id: vehicleSummary.year.toString(),
                    value: vehicleSummary.year.toString()
                },
            };
        case CatalogActions.GOT_OFFERS_ACTION.name:
            return {
                ...state,
                headlessGraphCms: {
                    ...state.headlessGraphCms,
                    offers: action.offers
                }
            };
        case CatalogActions.GOT_WIZARD_ACTION.name:
            return {
                ...state,
                headlessGraphCms: {
                    ...state.headlessGraphCms,
                    wizard: action.wizard
                }
            };
        case CatalogActions.GOT_BUREAU_CATALOG_ACTION.name:
            return {
                ...state,
                bureauCatalogs: action.bureauCatalogs
            };
        case CatalogActions.GOT_CHANNEL_REFERENTS_ACTION.name:
            return {
                ...state,
                channelReferents: action.channelReferents
            };
        case CatalogActions.GOT_CIVIL_STATUS_ACTION.name:
            return {
                ...state,
                civilStatus: action.civilStatus
            };
        case CatalogActions.GOT_REGIME_ACTION.name:
            return {
                ...state,
                regime: action.regime
            };
        case CatalogActions.GOT_ROL_HOME_ACTION.name:
            return {
                ...state,
                rolHome: action.rolHome
            };
        case CatalogActions.GOT_STUDIES_ACTION.name:
            return {
                ...state,
                studies: action.studies
            };
        case CatalogActions.GOT_ASSEMBLY_COUNTRY_ACTION.name:
            return {
                ...state,
                assemblyCountry: action.assemblyCountry
            };
        case CatalogActions.GOT_HOUSE_TYPE_ACTION.name:
            return {
                ...state,
                houseType: action.houseType
            };
        case CatalogActions.GOT_LAPSE_ACTION.name:
            return {
                ...state,
                lapse: action.lapse
            };
        case CatalogActions.GOT_EMPLOYMENT_ROTATION_ACTION.name:
            return {
                ...state,
                employmentRotation: action.employmentRotation
            };
        case CatalogActions.GOT_EMPLOYMENT_BILLING_TYPES_ACTION.name:
            return {
                ...state,
                employmentBillingTypes: action.billingTypes
            };
        case CatalogActions.GOT_EMPLOYMENT_TAX_REGIMES_ACTION.name:
            return {
                ...state,
                employmentTaxRegimes: action.taxRegimes
            };
        case UIActions.CLEAN_STATE_ACTION.name:
            CookieUtils.deleteCookie(StateConstants.YEAR_SELECTED);
            CookieUtils.deleteCookie(StateConstants.BRAND_SELECTED);
            CookieUtils.deleteCookie(StateConstants.MODEL_SELECTED);
            CookieUtils.deleteCookie(StateConstants.VERSION_SELECTED);
            CookieUtils.deleteCookie(StateConstants.POSTAL_CODE);
            CookieUtils.deleteCookie(StateConstants.ID_VEHICLE);
            CookieUtils.deleteCookie(StateConstants.GROUP_NAME);
            CookieUtils.deleteCookie(StateConstants.GROUP_ID);
            CookieUtils.deleteCookie(StateConstants.GROUP_LOCATION);
            CookieUtils.deleteCookie(StateConstants.ORIGINAL_PHOTO);
            CookieUtils.deleteCookie(StateConstants.THUMBNAIL_PHOTO);
            CookieUtils.deleteCookie(StateConstants.VEHICLE_PREMIUM_INFO);
            return defaultState.catalogs;
        case CatalogActions.GOT_ALL_QUOTATION_INSURANCES_ACTION.name:
            return {
                ...state,
                allQuotationInsurances: action.insurances.map(item => ({
                    ...item,
                    insuranceValueByYear: item.insuranceValueByYear.displayValue,
                    insuranceValueByYearValue: item.insuranceValueByYear.value
                }))
            };
        case CatalogActions.GOT_ALL_CATALOGS_SUCCESSFULLY.name:
            return {
                ...state,
                catalogIsLoaded: true
            };
        case WizardActions.CHANGE_INCLUDE_INSURANCE_ACTION.name:
            return {
                ...state,
                allQuotationInsurances: action.includeInsurance ? [] : state.allQuotationInsurances,
            };
        case CatalogActions.GOT_CR_GENDER_ACTION.name:
            return {
                ...state,
                crGender: action.gender,
            };
        case CatalogActions.GOT_CR_CIVIL_STATUS_ACTION.name:
            return {
                ...state,
                crCivilStatus: action.civilStatus,
            };
        case CatalogActions.GOT_CR_STUDIES_LEVEL_ACTION.name:
            return {
                ...state,
                crStudiesLevel: action.studiesLevel,
            };
        case CatalogActions.GOT_CR_COUNTRIES_WITH_NATIONALITIES_ACTION.name:
            return {
                ...state,
                countriesWithNationalities: action.countriesWithNationalities,
            };
        case CatalogActions.GOT_CR_HOUSE_TYPE_ACTION.name:
            return {
                ...state,
                crHouseType: action.houseType,
            };
        case CatalogActions.GOT_CR_DOCUMENT_TYPE_ACTION.name:
            return {
                ...state,
                crDocumentType: action.documentType,
            };
        case CatalogActions.GOT_CR_BUSINESS_TYPE_ACTION.name:
            return {
                ...state,
                crBusinessType: action.businessType,
            };
        default:
            return state;
    }
};

export default catalogs;
